/* eslint-disabled */
import Question from "./Question";
import TagExtend from "@/entity/extends/TagExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Tag extends TagExtend {

public id!: number;
public label = '';
public questions: Array<Question> = [];
public type = '';
public code = '';
public class? = '';

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
            hydrateCollection(object.questions, Question, this.questions);
       this.type= object.type;
       this.code= object.code;
       this.class= object.class;
      }
      this.postConstruct()
  }

}
